import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Alert,
  Box,
  Button,
  Container,
  Grid,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import AdminWorkspaceNav from '../components/AdminWorkspaceNav';
import ContextHelpButton from '../components/ContextHelpButton';

const glassPanelSx = {
  backgroundColor: 'rgba(255,255,255,0.72)',
  backdropFilter: 'blur(14px)',
  borderRadius: 3,
  boxShadow: '0 12px 30px rgba(0,0,0,0.08)',
};

const managerCards = [
  {
    title: 'Artist Manager',
    description:
      'Review existing artist profiles, track profile completeness, and update live artist-facing fields.',
    cta: 'Open Artist Manager',
    to: '/admin/artists',
  },
  {
    title: 'Host Manager',
    description:
      'Manage host profiles, venue details, and operational host information.',
    cta: 'Open Host Manager',
    to: '/admin/hosts',
  },
  {
    title: 'Buyer Manager',
    description:
      'Review buyer profiles, preferences, and buyer-related account records.',
    cta: 'Open Buyer Manager',
    to: '/admin/buyers',
  },
  {
    title: 'Artwork Manager',
    description:
      'Manage artwork records inside the same admin namespace as the other platform manager pages.',
    cta: 'Open Artwork Manager',
    to: '/admin/artworks',
  },
];

export default function AdminPage() {
  return (
    <Container sx={{ mt: 5, mb: 6 }}>
      <Stack spacing={3}>
        <Box>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2 }}>
            <Typography variant="h4" gutterBottom sx={{ fontWeight: 700, mb: 0 }}>
              Admin Workspace
            </Typography>
            <ContextHelpButton section="admin-help" title="Help for admin workspace" />
          </Box>
          <Typography variant="body1" color="text.secondary">
            Central place for the platform’s manager pages. This keeps artist, host, and buyer administration in one predictable area.
          </Typography>
        </Box>

        <AdminWorkspaceNav subtitle="Use the shared admin navigation below to move between manager pages without falling back to one-off URLs." />

        <Alert severity="info">
          The artist, host, and buyer managers are now grouped under a shared admin workspace with consistent routing and navigation.
        </Alert>

        <Grid container spacing={3}>
          {managerCards.map((card) => (
            <Grid item xs={12} md={6} lg={3} key={card.title}>
              <Paper sx={{ ...glassPanelSx, p: 3, height: '100%' }}>
                <Stack spacing={2} sx={{ height: '100%' }}>
                  <Typography variant="h6" sx={{ fontWeight: 700 }}>
                    {card.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ flexGrow: 1 }}>
                    {card.description}
                  </Typography>
                  <Button component={RouterLink} to={card.to} variant="contained">
                    {card.cta}
                  </Button>
                </Stack>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Stack>
    </Container>
  );
}
